module.exports = __webpack_public_path__ + "static/media/Orthopedics-Knee Condition Intake-2@3x.a21582f4.png";